export enum ReportsLoginsRoutes {
    userDeviceInfo = "user-device-reports",
    userMobileAccess = "user-mobile-reports",
    loginHistory = "login-history",
    loginHistoryDetails = "login-history-details",
    loginHistoryDetail = "login-history-detail",
}
